import Loader from "components/loader";
import ScanQRcode from "components/wallet/settings-security/two-factor-setup/desktop/Models/ScanQRcode";
import { useTheme } from "hooks/useTheme";
import AuthenticatedLayout from "layouts/authenticated";
import UnauthenticatedLayout from "layouts/unauthenticated";
import ErrorPage from "modules/authenticated/error-page";
import HfDashboard from "modules/authenticated/health-facility/hf-dashboard";
import StaffPermission from "modules/authenticated/end-user/settings/staff-permission";
import UpdateHfProfile from "modules/authenticated/end-user/settings/update-hf-profile";
import { lazy, Suspense } from "react";
import { createBrowserRouter, Outlet, RouterProvider } from "react-router-dom";
import Invoice from "modules/authenticated/health-facility/invoice-history";
import InvoiceView from "modules/authenticated/health-facility/invoice-card";

// add business wallet settings

const Enable2FA = lazy(
  () =>
    import(
      "components/wallet/settings-security/two-factor-setup/desktop/Models/Enable2FA"
    )
);
const ProvideEmail = lazy(
  () =>
    import(
      "components/wallet/settings-security/two-factor-setup/desktop/Models/ProvideEmail"
    )
);
const Provide2FOTP = lazy(
  () =>
    import(
      "components/wallet/settings-security/two-factor-setup/desktop/Models/ProvideOTP"
    )
);

const TwoFactorSetupPage = lazy(
  () =>
    import(
      "modules/authenticated/end-user/wallet/settings-security/two-factor-setup"
    )
);
const ProvideOTP = lazy(
  () => import("components/wallet/fund-transfer/Desktop/Models/ProvideOTP")
);
const ProvidePassword = lazy(
  () => import("components/wallet/fund-transfer/Desktop/Models/ProvidePassword")
);
const WalletProvidePassword = lazy(
  () =>
    import("components/wallet/withdrawal/Desktop/Models/WalletProvidePassword")
);
const Login = lazy(() => import("modules/unauthenticated/login"));

const ForgotPassword = lazy(
  () => import("modules/unauthenticated/forgot-password")
);
const NotificationSettingsContainer = lazy(
  () => import("components/wallet/settings-security/notification-setting")
);
const StaffComponent = lazy(
  () => import("modules/authenticated/health-facility/users/staff")
);
const ClientComponent = lazy(
  () => import("modules/authenticated/health-facility/users/client/list-client")
);
const TransferClient = lazy(
  () =>
    import("modules/authenticated/health-facility/users/client/transfer-client")
);

const ManageBanks = lazy(
  () => import("modules/authenticated/end-user/wallet/manage-banks")
);
const Resgister = lazy(() => import("modules/unauthenticated/register"));
const VerifyEmail = lazy(() => import("modules/unauthenticated/verify"));
const AddBankAccountComponent = lazy(
  () => import("modules/authenticated/end-user/wallet/add-bank-account")
);

const Dashboard = lazy(
  () => import("modules/authenticated/end-user/dashboard")
);
const DependantDashboard = lazy(
  () => import("components/pages/end-user/manage-family/dependant")
);

const MyVaccination = lazy(
  () => import("modules/authenticated/end-user/my-vaccination")
);

const MyVaccinationDetail = lazy(
  () => import("modules/authenticated/end-user/my-vaccination/detail")
);
const ReminderHistory = lazy(() => import("components/reminder-history"));
const DownloadHistory = lazy(() => import("components/download-history"));

const BookingHistory = lazy(
  () => import("modules/authenticated/end-user/history/booking-history")
);

const BookAppointment = lazy(
  () => import("modules/authenticated/end-user/book-appointment")
);

const BookAppointmentDashboard = lazy(
  () => import("modules/authenticated/end-user/book-appointment/dashboard")
);

const BookAppointmentLocation = lazy(
  () => import("modules/authenticated/end-user/book-appointment/location")
);

const BookAppointmentHomeAddress = lazy(
  () => import("modules/authenticated/end-user/book-appointment/home-address")
);

const BookAppointmentVaccines = lazy(
  () => import("modules/authenticated/end-user/book-appointment/vaccines")
);

const BookAppointmentVaccineBrand = lazy(
  () => import("modules/authenticated/end-user/book-appointment/vaccine-brand")
);

const BookAppointmentAppointmentDate = lazy(
  () =>
    import("modules/authenticated/end-user/book-appointment/appointment-date")
);

const BookAppointmentBookingSummary = lazy(
  () =>
    import("modules/authenticated/end-user/book-appointment/booking-summary")
);

const BookingPayment = lazy(
  () =>
    import("modules/authenticated/end-user/book-appointment/booking-payment")
);
const BookingSuccessful = lazy(
  () =>
    import("modules/authenticated/end-user/book-appointment/booking-successful")
);

const Wallet = lazy(() => import("modules/authenticated/end-user/wallet"));

const WalletAddFunds = lazy(
  () => import("modules/authenticated/end-user/wallet/fund-wallet/index")
);

const WalletTransferFunds = lazy(
  () => import("modules/authenticated/end-user/wallet/fund-transfer")
);
const WalletWithdrawFunds = lazy(
  () => import("modules/authenticated/end-user/wallet/withdrawal")
);
const WalletTransactionHistory = lazy(
  () => import("modules/authenticated/end-user/wallet/transaction-history")
);
const WalletSettings = lazy(
  () => import("modules/authenticated/end-user/wallet/settings-security")
);

const BusinessWallet = lazy(
  () => import("modules/authenticated/health-facility/business-wallet")
);

const BusinessWalletWithdraw = lazy(
  () => import("modules/authenticated/health-facility/business-wallet/withdraw")
);

const WidthDrawAddAccount = lazy(
  () =>
    import(
      "modules/authenticated/health-facility/business-wallet/withdraw/add-bank"
    )
);

const BusinessManageAccounts = lazy(
  () =>
    import(
      "modules/authenticated/health-facility/business-wallet/withdraw/manage-bank"
    )
);

const BusinessWalletProvidePassword = lazy(
  () =>
    import(
      "components/business-wallet/withdrawal/desktop/models/WalletProvidePassword"
    )
);

const BusinessWalletSettings = lazy(
  () =>
    import("modules/authenticated/end-user/business-wallet/settings-security")
);

const Recommendations = lazy(
  () => import("modules/authenticated/end-user/recommendation")
);

const Managefamilyaccounts = lazy(
  () => import("modules/authenticated/end-user/manage-family-accounts")
);

const Settings = lazy(() => import("modules/authenticated/end-user/settings"));

const SettingsResetPassword = lazy(
  () => import("modules/authenticated/end-user/settings/reset-password")
);

const ResetPassword = lazy(
  () => import("modules/unauthenticated/reset-password")
);

const UpdateProfile = lazy(
  () => import("modules/authenticated/end-user/settings/update-profile")
);

const CreateHF = lazy(
  () => import("modules/authenticated/health-facility/create-hf")
);
const AllShots = lazy(
  () => import("modules/authenticated/health-facility/vaccinations/all-shots")
);
const Branches = lazy(
  () => import("modules/authenticated/health-facility/branches")
);
const HfReminderHistory = lazy(
  () =>
    import("modules/authenticated/health-facility/reminder/reminder-history")
);
const HfManualReminder = lazy(
  () => import("modules/authenticated/health-facility/reminder/manual-reminder")
);
const SendManualReminder = lazy(
  () =>
    import(
      "modules/authenticated/health-facility/reminder/manual-reminder/send-manual-reminder"
    )
);

// Reports imports
const ClinicalNotes = lazy(
  () => import("modules/authenticated/health-facility/reports/clinical-notes")
);

const AddClinicalNotes = lazy(
  () =>
    import("modules/authenticated/health-facility/reports/add-clinical-notes")
);

const ClinicalNotesProfile = lazy(
  () =>
    import(
      "modules/authenticated/health-facility/reports/clinical-notes-profile"
    )
);

const CreateLaboratoryTest = lazy(
  () =>
    import(
      "modules/authenticated/health-facility/reports/create-laboratory-test"
    )
);

const DownloadRecord = lazy(
  () => import("modules/authenticated/health-facility/reports/download-record")
);

const DownloadReportHistory = lazy(
  () => import("modules/authenticated/health-facility/reports/download-history")
);

// vaccinations imports
const AllVaccinations = lazy(
  () =>
    import(
      "modules/authenticated/health-facility/vaccinations/all-vaccinations"
    )
);

const CreateVaccination = lazy(
  () =>
    import(
      "modules/authenticated/health-facility/vaccinations/all-vaccinations/create-vaccination"
    )
); // subroute

const ContinuedVaccination = lazy(
  () =>
    import(
      "modules/authenticated/health-facility/vaccinations/continued-vaccinations"
    )
);

const ContinuedVaccinationDet = lazy(
  () =>
    import(
      "modules/authenticated/health-facility/vaccinations/continued-vaccinations/details"
    )
);

const ConVaccAddAnotherShot = lazy(
  () =>
    import(
      "modules/authenticated/health-facility/vaccinations/continued-vaccinations/add-another-shot"
    )
);

const AdministeredShots = lazy(
  () =>
    import(
      "modules/authenticated/health-facility/vaccinations/administered-shots"
    )
);

const UpcomingShots = lazy(
  () =>
    import("modules/authenticated/health-facility/vaccinations/upcoming-shots")
);

const DueShots = lazy(
  () => import("modules/authenticated/health-facility/vaccinations/due-shots")
);

const AefiHistory = lazy(
  () =>
    import("modules/authenticated/health-facility/vaccinations/aefi-history")
);

const AefiDashboard = lazy(
  () =>
    import("modules/authenticated/health-facility/vaccinations/aefi-dashboard")
);

// business profile
const BusinessProfile = lazy(
  () => import("modules/authenticated/health-facility/business-profile")
);

// Messaging
const Messaging = lazy(
  () => import("modules/authenticated/health-facility/messaging")
);
const SendBulkMessages = lazy(
  () =>
    import("modules/authenticated/health-facility/messaging/send-bulk-messages")
);

// Inventory
const Inventory = lazy(
  () => import("modules/authenticated/health-facility/inventory")
);

const ItemsList = lazy(
  () => import("modules/authenticated/health-facility/inventory/items-list")
);

const SupplyList = lazy(
  () => import("modules/authenticated/health-facility/inventory/supply-list")
);

const PlaceOrder = lazy(
  () => import("modules/authenticated/health-facility/inventory/place-order")
);

const Reduce = lazy(
  () => import("modules/authenticated/health-facility/inventory/reduce")
);

const Replenish = lazy(
  () => import("modules/authenticated/health-facility/inventory/replenish")
);

const Details = lazy(
  () => import("modules/authenticated/health-facility/inventory/details")
);

const History = lazy(
  () => import("modules/authenticated/health-facility/inventory/history")
);

// Manage subscriptions
const ManageSubscriptions = lazy(
  () => import("modules/authenticated/health-facility/manage-subscriptions")
);

const LearningDevelopment = lazy(
  () => import("modules/shared/learning-development")
);

const AllContents = lazy(
  () => import("modules/shared/learning-development/all-contents")
);

const AddContent = lazy(
  () => import("modules/shared/learning-development/add-contents")
);

const Content = lazy(
  () => import("modules/shared/learning-development/content")
);

// Help center
const HelpCenter = lazy(
  () => import("modules/authenticated/health-facility/help-center")
);

interface Props {
  children?: React.ReactNode;
}

const MainBody = ({ children }: Props) => {
  const { theme } = useTheme();
  return (
    <div
      className={`h-dvh w-full !font-inter ${
        theme === "light"
          ? "bg-white text-bg-gray-900"
          : "bg-gray-900 text-white"
      }`}
    >
      {children ? children : <Outlet />}
    </div>
  );
};

export const ISuspense = ({ children }: Props) => {
  return <Suspense children={children} fallback={<Loader />} />;
};

const MainRoutes = () => {
  const modules = createBrowserRouter([
    {
      element: <MainBody />,
      children: [
        {
          path: "/",
          element: <AuthenticatedLayout />,
          // errorElement: <ErrorPage errorType="400" />,
          children: [
            {
              index: true,
              element: (
                <ISuspense>
                  <Dashboard />
                </ISuspense>
              ),
              errorElement: <ErrorPage errorType="400" />,
            },
            {
              path: "my-vaccinations",
              children: [
                {
                  index: true,
                  element: (
                    <ISuspense>
                      <MyVaccination />
                    </ISuspense>
                  ),
                  errorElement: <ErrorPage errorType="400" />,
                },
                {
                  path: ":id",
                  element: (
                    <ISuspense>
                      <MyVaccinationDetail />
                    </ISuspense>
                  ),
                  errorElement: <ErrorPage errorType="400" />,
                },
              ],
            },
            {
              path: "reminder-history",
              element: (
                <ISuspense>
                  <ReminderHistory />
                </ISuspense>
              ),
              errorElement: <ErrorPage errorType="400" />,
            },
            {
              path: "download-history",
              element: (
                <ISuspense>
                  <DownloadHistory />
                </ISuspense>
              ),
              errorElement: <ErrorPage errorType="400" />,
            },
            {
              path: "history",
              children: [
                {
                  index: true,
                  element: (
                    <ISuspense>
                      <h1 children="dynamic History" />
                    </ISuspense>
                  ),
                },
                {
                  path: "reminder-history",
                  element: (
                    <ISuspense>
                      <ReminderHistory />
                    </ISuspense>
                  ),
                },
                {
                  path: "download-history",
                  element: (
                    <ISuspense>
                      <DownloadHistory />
                    </ISuspense>
                  ),
                },
                {
                  path: "informed-consent-history",
                  element: (
                    <ISuspense>
                      <h1 children="dynamic Informed Consent History" />
                    </ISuspense>
                  ),
                },
                {
                  path: "booking-history",
                  element: (
                    <ISuspense>
                      <BookingHistory />
                    </ISuspense>
                  ),
                },
              ],
            },
            {
              path: "/book-appointment",
              element: (
                <ISuspense>
                  <BookAppointment />
                </ISuspense>
              ),
              errorElement: <ErrorPage errorType="400" />,
              children: [
                {
                  index: true,
                  element: (
                    <ISuspense>
                      <BookAppointmentDashboard />
                    </ISuspense>
                  ),
                  errorElement: <ErrorPage errorType="400" />,
                },
                {
                  path: ":location",
                  children: [
                    {
                      path: "",
                      element: (
                        <ISuspense>
                          <BookAppointmentLocation />
                        </ISuspense>
                      ),
                      errorElement: <ErrorPage errorType="400" />,
                    },
                    {
                      path: "home-address",
                      element: (
                        <ISuspense>
                          <BookAppointmentHomeAddress />
                        </ISuspense>
                      ),
                      errorElement: <ErrorPage errorType="400" />,
                    },
                    {
                      path: "vaccines",
                      children: [
                        {
                          index: true,
                          element: (
                            <ISuspense>
                              <BookAppointmentVaccines />
                            </ISuspense>
                          ),
                          errorElement: <ErrorPage errorType="400" />,
                        },
                        {
                          path: ":vaccineBrand",
                          element: (
                            <ISuspense>
                              <BookAppointmentVaccineBrand />
                            </ISuspense>
                          ),
                          errorElement: <ErrorPage errorType="400" />,
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              path: "appointment-date",
              element: (
                <ISuspense>
                  <BookAppointmentAppointmentDate />
                </ISuspense>
              ),
              errorElement: <ErrorPage errorType="400" />,
            },
            {
              path: "booking-summary",
              children: [
                {
                  index: true,
                  element: (
                    <ISuspense>
                      <BookAppointmentBookingSummary />
                    </ISuspense>
                  ),
                  errorElement: <ErrorPage errorType="400" />,
                },
                {
                  path: "booking-payment/:appointmentId",
                  element: (
                    <ISuspense>
                      <BookingPayment />
                    </ISuspense>
                  ),
                  errorElement: <ErrorPage errorType="400" />,
                },
                {
                  path: "booking-successful",
                  element: (
                    <ISuspense>
                      <BookingSuccessful />
                    </ISuspense>
                  ),
                  errorElement: <ErrorPage errorType="400" />,
                },
              ],
            },
            {
              path: "wallet",
              children: [
                {
                  index: true,
                  element: (
                    <ISuspense>
                      <Wallet />
                    </ISuspense>
                  ),
                  errorElement: <ErrorPage errorType="400" />,
                },
                {
                  path: "transaction-history",
                  element: (
                    <ISuspense>
                      <WalletTransactionHistory />
                    </ISuspense>
                  ),
                },
                {
                  path: "add-funds",
                  element: (
                    <ISuspense>
                      <WalletAddFunds />
                    </ISuspense>
                  ),
                },
                {
                  path: "transfer",
                  children: [
                    {
                      index: true,
                      element: (
                        <ISuspense>
                          <WalletTransferFunds />
                        </ISuspense>
                      ),
                    },
                    {
                      path: "provide-password",
                      children: [
                        {
                          index: true,
                          element: (
                            <ISuspense>
                              <ProvidePassword />
                            </ISuspense>
                          ),
                        },
                        {
                          path: "provide-otp",
                          element: (
                            <ISuspense>
                              <ProvideOTP />
                            </ISuspense>
                          ),
                        },
                      ],
                    },
                  ],
                },
                {
                  path: "withdraw",
                  children: [
                    {
                      index: true,
                      element: (
                        <ISuspense>
                          <WalletWithdrawFunds />
                        </ISuspense>
                      ),
                    },
                    {
                      path: "provide-password",
                      element: (
                        <ISuspense>
                          <WalletProvidePassword />
                        </ISuspense>
                      ),
                    },
                    {
                      path: "manage-banks",
                      children: [
                        {
                          index: true,

                          element: (
                            <ISuspense>
                              <ManageBanks />
                            </ISuspense>
                          ),
                        },
                        {
                          path: "add-new-bank",
                          element: (
                            <ISuspense>
                              <AddBankAccountComponent />
                            </ISuspense>
                          ),
                        },
                      ],
                    },
                  ],
                },
                {
                  path: "settings",
                  children: [
                    {
                      index: true,
                      element: (
                        <ISuspense>
                          <WalletSettings />
                        </ISuspense>
                      ),
                    },
                    {
                      path: "two-factor-setup",
                      children: [
                        {
                          index: true,
                          element: (
                            <ISuspense>
                              <TwoFactorSetupPage />
                            </ISuspense>
                          ),
                        },
                        {
                          path: "provide-email",
                          element: (
                            <ISuspense>
                              <ProvideEmail />
                            </ISuspense>
                          ),
                        },
                        {
                          path: "provide-otp",
                          element: (
                            <ISuspense>
                              <Provide2FOTP />
                            </ISuspense>
                          ),
                        },
                        {
                          path: "enable2fa",
                          element: (
                            <ISuspense>
                              <Enable2FA />
                            </ISuspense>
                          ),
                        },
                        {
                          path: "provide-qr-code",
                          element: (
                            <ISuspense>
                              <ScanQRcode />
                            </ISuspense>
                          ),
                        },
                      ],
                    },
                    {
                      path: "notification-setting",
                      element: (
                        <ISuspense>
                          <NotificationSettingsContainer />
                        </ISuspense>
                      ),
                    },
                  ],
                },
                {
                  path: "*",
                  element: (
                    <ISuspense>
                      <h2>404 Page Not Found</h2>
                    </ISuspense>
                  ),
                },
              ],
            },
            {
              path: "recommendations",
              element: (
                <ISuspense>
                  <Recommendations />
                </ISuspense>
              ),
            },
            {
              path: "manage-family-accounts",
              children: [
                {
                  index: true,
                  element: (
                    <ISuspense>
                      <Managefamilyaccounts />
                    </ISuspense>
                  ),
                },
                {
                  path: ":id",
                  children: [
                    {
                      index: true,
                      element: (
                        <ISuspense>
                          <DependantDashboard />
                        </ISuspense>
                      ),
                    },
                    {
                      path: "vaccination",
                      element: (
                        <ISuspense>
                          <h1 children="yooo" />
                        </ISuspense>
                      ),
                    },
                  ],
                  // element: (
                  //   <ISuspense>
                  //     <DependantDashboard />
                  //   </ISuspense>
                  // ),
                },
              ],
            },
            // {
            //   path: "learning-development",
            //   element: (
            //     <ISuspense>
            //       <LearningDevelopment />
            //     </ISuspense>
            //   ),
            //   children: [
            //     {
            //       index: true,
            //       element: (
            //         <ISuspense>
            //           <AllContents />
            //         </ISuspense>
            //       ),
            //     },
            //     {
            //       path: "add-content",
            //       element: (
            //         <ISuspense>
            //           <AddContent />
            //         </ISuspense>
            //       ),
            //     },
            //   ],
            // },
            {
              path: "create-hf",
              element: (
                <ISuspense>
                  <CreateHF />
                </ISuspense>
              ),
            },
            {
              path: "settings",
              element: (
                <ISuspense>
                  <Settings />
                </ISuspense>
              ),
              children: [
                {
                  index: true,
                  element: (
                    <ISuspense>
                      <SettingsResetPassword />
                    </ISuspense>
                  ),
                },
                {
                  path: "update-profile",
                  element: (
                    <ISuspense>
                      <UpdateProfile />
                    </ISuspense>
                  ),
                },
                {
                  path: "update-hf-profile",
                  element: (
                    <ISuspense>
                      <UpdateHfProfile />
                    </ISuspense>
                  ),
                },
                {
                  path: "staff-permission",
                  element: (
                    <ISuspense>
                      <StaffPermission />
                    </ISuspense>
                  ),
                },
              ],
            },
            {
              path: "help-center",
              element: (
                <ISuspense>
                  <HelpCenter />
                </ISuspense>
              ),
            },

            {
              path: ":dynamic",
              children: [
                {
                  index: true,
                  element: (
                    <ISuspense>
                      <HfDashboard />
                    </ISuspense>
                  ),
                },
                {
                  path: "business-wallet",
                  children: [
                    {
                      index: true,
                      element: (
                        <ISuspense>
                          <BusinessWallet />
                        </ISuspense>
                      ),
                    },
                    {
                      path: "add-funds",
                      element: (
                        <ISuspense>
                          <WalletAddFunds />
                        </ISuspense>
                      ),
                    },
                    {
                      path: "transfer",
                      element: (
                        <ISuspense>
                          <WalletTransferFunds />
                        </ISuspense>
                      ),
                    },
                    {
                      path: "withdraw",
                      children: [
                        {
                          index: true,
                          element: (
                            <ISuspense>
                              <BusinessWalletWithdraw />
                            </ISuspense>
                          ),
                        },
                        {
                          path: "add-bank",
                          element: (
                            <ISuspense>
                              <WidthDrawAddAccount />
                            </ISuspense>
                          ),
                        },
                        {
                          path: "edit-bank",
                          element: (
                            <ISuspense>
                              <WidthDrawAddAccount />
                            </ISuspense>
                          ),
                        },
                        {
                          path: "manage-banks",
                          element: (
                            <ISuspense>
                              <BusinessManageAccounts />
                            </ISuspense>
                          ),
                        },
                        {
                          path: "provide-password",
                          element: (
                            <ISuspense>
                              <BusinessWalletProvidePassword />
                            </ISuspense>
                          ),
                        },
                      ],
                    },
                    {
                      path: "settings",
                      element: (
                        <ISuspense>
                          <BusinessWalletSettings />
                        </ISuspense>
                      ),
                    },
                  ],
                },
                {
                  path: "vaccinations",
                  children: [
                    {
                      path: "all-vaccinations",
                      children: [
                        {
                          index: true,
                          element: (
                            <ISuspense>
                              <AllVaccinations />
                            </ISuspense>
                          ),
                        },
                        {
                          path: "create-vaccination",
                          element: (
                            <ISuspense>
                              <CreateVaccination />
                            </ISuspense>
                          ),
                        },
                      ],
                    },
                    {
                      path: "continued-vaccinations",
                      children: [
                        {
                          index: true,
                          element: (
                            <ISuspense>
                              <ContinuedVaccination />
                            </ISuspense>
                          ),
                        },
                        {
                          path: ":vid",
                          children: [
                            {
                              index: true,
                              element: (
                                <ISuspense>
                                  <ContinuedVaccinationDet />
                                </ISuspense>
                              ),
                            },
                            {
                              path: "another-shot",
                              element: (
                                <ISuspense>
                                  <ConVaccAddAnotherShot />
                                </ISuspense>
                              ),
                            },
                          ],
                        },
                      ],
                    },

                    {
                      path: "all-shots",
                      children: [
                        {
                          index: true,
                          element: (
                            <ISuspense>
                              <AllShots />
                            </ISuspense>
                          ),
                        },
                        {
                          path: "administered-shots",
                          element: (
                            <ISuspense>
                              <AdministeredShots />
                            </ISuspense>
                          ),
                        },
                        {
                          path: "upcoming-shots",
                          element: (
                            <ISuspense>
                              <UpcomingShots />
                            </ISuspense>
                          ),
                        },
                        {
                          path: "due-shots",
                          element: (
                            <ISuspense>
                              <DueShots />
                            </ISuspense>
                          ),
                        },
                      ],
                    },
                    {
                      path: "aefi",
                      children: [
                        {
                          path: "dashboard",
                          element: (
                            <ISuspense>
                              <AefiDashboard />
                            </ISuspense>
                          ),
                        },
                        {
                          path: "aefi-history",
                          element: (
                            <ISuspense>
                              <AefiHistory />
                            </ISuspense>
                          ),
                        },
                      ],
                    },
                  ],
                },
                {
                  path: "users",
                  children: [
                    {
                      path: "clients",
                      children: [
                        {
                          path: "list-clients",
                          element: (
                            <ISuspense>
                              <ClientComponent />
                            </ISuspense>
                          ),
                        },
                        {
                          path: "transfer-client",
                          element: (
                            <ISuspense>
                              <TransferClient />
                            </ISuspense>
                          ),
                        },
                      ],
                    },
                    {
                      path: "staffs",
                      element: (
                        <ISuspense>
                          <StaffComponent />
                        </ISuspense>
                      ),
                    },
                  ],
                },
                {
                  path: "reminder",
                  children: [
                    {
                      path: "reminder-history",
                      element: (
                        <ISuspense>
                          <HfReminderHistory />
                        </ISuspense>
                      ),
                    },
                    {
                      path: "manual-reminder",
                      children: [
                        {
                          index: true,
                          element: (
                            <ISuspense>
                              <HfManualReminder />
                            </ISuspense>
                          ),
                        },
                        {
                          path: "send-manual-reminder",
                          element: (
                            <ISuspense>
                              <SendManualReminder />
                            </ISuspense>
                          ),
                        },
                      ],
                    },
                  ],
                },
                {
                  path: "reports",
                  children: [
                    {
                      path: "clinical-notes",
                      children: [
                        {
                          index: true,
                          element: (
                            <ISuspense>
                              <ClinicalNotes />
                            </ISuspense>
                          ),
                        },
                        {
                          path: "add-clinical-note",
                          element: (
                            <ISuspense>
                              <h1 children="dynamic create-clinical-note" />
                            </ISuspense>
                          ),
                        },
                        {
                          path: "view-clinical-note",
                          element: (
                            <ISuspense>
                              <h1 children="dynamic view-clinical-note" />
                            </ISuspense>
                          ),
                        },
                      ],
                    },
                    {
                      path: "add-clinical-notes",
                      element: (
                        <ISuspense>
                          <AddClinicalNotes />
                        </ISuspense>
                      ),
                    },
                    {
                      path: "clinical-notes-profile/:noteId",
                      element: (
                        <ISuspense>
                          <ClinicalNotesProfile />
                        </ISuspense>
                      ),
                    },
                    {
                      path: "create-labroartory-test",
                      element: (
                        <ISuspense>
                          <CreateLaboratoryTest />
                        </ISuspense>
                      ),
                    },
                    {
                      path: "download-record",
                      element: (
                        <ISuspense>
                          <DownloadRecord />
                        </ISuspense>
                      ),
                    },
                    {
                      path: "download-history",
                      element: (
                        <ISuspense>
                          <DownloadReportHistory />
                        </ISuspense>
                      ),
                    },
                  ],
                },
                {
                  path: "manual-reminder",
                  element: (
                    <ISuspense>
                      <h1 children="dynamic Manual Reminder" />
                    </ISuspense>
                  ),
                },
                {
                  path: "messaging",
                  children: [
                    {
                      index: true,
                      element: (
                        <ISuspense>
                          <Messaging />
                        </ISuspense>
                      ),
                    },
                    {
                      path: "send-bulk-messages",
                      element: (
                        <ISuspense>
                          <SendBulkMessages />
                        </ISuspense>
                      ),
                    },
                  ],
                },
                {
                  path: "invoice-history",
                  children: [
                    {
                      index: true,
                      element: (
                        <ISuspense>
                          <Invoice />
                        </ISuspense>
                      ),
                    },

                    {
                      path: "view-invoice",
                      element: (
                        <ISuspense>
                          <InvoiceView />
                        </ISuspense>
                      ),
                    },
                  ],
                },
                {
                  path: "branches",
                  element: (
                    <ISuspense>
                      <Branches />
                    </ISuspense>
                  ),
                },
                {
                  path: "business-profile",
                  element: (
                    <ISuspense>
                      <BusinessProfile />
                    </ISuspense>
                  ),
                },
                {
                  path: "inventory",
                  children: [
                    {
                      index: true,
                      element: (
                        <ISuspense>
                          <Inventory />
                        </ISuspense>
                      ),
                    },
                    {
                      path: "item-list",
                      element: (
                        <ISuspense>
                          <ItemsList />
                        </ISuspense>
                      ),
                    },
                    {
                      path: "supply-list",
                      element: (
                        <ISuspense>
                          <SupplyList />
                        </ISuspense>
                      ),
                    },
                    {
                      path: "place-order",
                      element: (
                        <ISuspense>
                          <PlaceOrder />
                        </ISuspense>
                      ),
                    },
                    {
                      path: "reduce",
                      element: (
                        <ISuspense>
                          <Reduce />
                        </ISuspense>
                      ),
                    },
                    {
                      path: "replenish",
                      element: (
                        <ISuspense>
                          <Replenish />
                        </ISuspense>
                      ),
                    },
                    {
                      path: "details",
                      element: (
                        <ISuspense>
                          <Details />
                        </ISuspense>
                      ),
                    },
                    {
                      path: "history",
                      element: (
                        <ISuspense>
                          <History />
                        </ISuspense>
                      ),
                    },
                  ],
                },
                {
                  path: "subscriptions",
                  element: (
                    <ISuspense>
                      <ManageSubscriptions />
                    </ISuspense>
                  ),
                },
                {
                  path: "*",
                  element: <ErrorPage errorType="404" />,
                },
              ],
            },
            {
              path: "*",
              element: <ErrorPage errorType="404" />,
            },
          ],
        },

        {
          path: "/auth",
          element: <UnauthenticatedLayout />,
          errorElement: <ErrorPage errorType="400" />,
          children: [
            {
              index: true,
              element: (
                <ISuspense>
                  <Login />
                </ISuspense>
              ),
            },
            {
              path: "signup",
              element: (
                <ISuspense>
                  <Resgister />
                </ISuspense>
              ),
            },
            {
              path: "verify",
              element: (
                <ISuspense>
                  <VerifyEmail />
                </ISuspense>
              ),
            },
            {
              path: "forgotPassword",
              element: (
                <ISuspense>
                  <ForgotPassword />
                </ISuspense>
              ),
            },
            {
              path: "reset-password",
              element: (
                <ISuspense>
                  <ResetPassword />
                </ISuspense>
              ),
            },
          ],
        },

        {
          path: "not-found",
          element: <ErrorPage errorType="404" />,
        },

        {
          path: "learning-development",
          element: (
            <ISuspense>
              <LearningDevelopment />
            </ISuspense>
          ),
          children: [
            {
              index: true,
              element: (
                <ISuspense>
                  <AllContents />
                </ISuspense>
              ),
            },
            {
              path: "add-content",
              element: (
                <ISuspense>
                  <AddContent />
                </ISuspense>
              ),
            },
            {
              path: "content/:slug",
              element: (
                <ISuspense>
                  <Content />
                </ISuspense>
              ),
            },
          ],
        },
      ],
    },
  ]);
  return <RouterProvider router={modules} />;
};

export default MainRoutes;
